var $ = require('jquery');
var TorsoFormView = require('backbone-torso/modules/FormView');
var TorsoEvents = require('backbone-torso/modules/Events');

/**
 * Form View in Accordion Style
 *
 * @class AccordionFormWidget
 */
module.exports = TorsoFormView.extend({
  className: 'brec-accordion',

  events: {
    'click [data-accordion]': '_toggleAccordion',
    'keyup [data-accordion]': '_keyboardSupport',
    'click [data-return-top]': '_scrollToTop',
  },

  prepareFields: {
    'accordionContentViewId': 'accordionContentViewId',
    'accordionTriggerMessageKey': function() {
      return $.i18n.prop(this.accordionTriggerMessageKey);
    }
  },

  _defaultAccordionContentViewId: '',
  _defaultAccordionTriggerMessageKey: '',

  /**
   * Show/Hide Accordion Content
   * @method _toggleAccordion
   * @private
   */
  _toggleAccordion: function() {
    var showAccordionContent = this.get('showAccordionContent');
    this.set('showAccordionContent', !showAccordionContent);
  },

  /**
   * Press Enter Key to trigger the _toggleAccordion function
   * @method _keyboardSupport
   * @private
   */
  _keyboardSupport: function(event) {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this._toggleAccordion();
    }
  },

  /**
   * Scroll to page header
   * @method _scrollToTop
   * @param event {jQuery.Event} the jquery event that triggered this method.
   * @private
   */
  _scrollToTop: function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: (0)
    });
  },

  /**
   * Scroll to anchor
   * @method _scrollToTrigger
   * @param anchor {String} the anchor name to scroll to
   * @private
   */
  _scrollToTrigger: function(anchor) {
    $('html, body').animate({
      scrollTop: this.$el.find('#' + anchor).offset().top
    });
  },

 /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view
   *  @param options.model {Object} the form model that is passed to this form view
   *  @param options.template {Object} the form template
   *  @param options.accordionContentViewId {String} the id of this view
   *  @param options.accordionTriggerMessageKey {String} the i18n message key for the trigger
   */
  initialize: function(options) {
    this.model = options.model;
    this.template = options.template || this.template;
    this.accordionContentViewId = options.accordionContentViewId || this._defaultAccordionContentViewId;
    this.accordionTriggerMessageKey = options.accordionTriggerMessageKey || this._defaultAccordionTriggerMessageKey;

    this.set('showAccordionContent', false);
    this.on('change:showAccordionContent', function() {
      TorsoEvents.trigger('accordion:showAccordionContentChanged');
      this.render();
    });
  }
});
